import { render, staticRenderFns } from "./createStudentMeal.vue?vue&type=template&id=6ea697a8&"
import script from "./createStudentMeal.vue?vue&type=script&lang=js&"
export * from "./createStudentMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports